'use client';

import dynamic from 'next/dynamic';

/**
 * Загрузчик GA4 отдельным куском скриптов, который скачивается, только
 * когда компонент действительно стоит на странице.
 *
 * Зачем обёртка. Макет витрины AiSearch, кабинета и страниц входа общий у
 * aisearch.tech и aisearch.ru, и сборщик кладёт в скрипты макета все
 * клиентские компоненты, которые он импортирует, — даже те, что на
 * русском домене не отрисовываются. Без обёртки на aisearch.ru вместе с
 * макетом приезжали бы адрес googletagmanager.com и коды потоков (замерено
 * 16.10 на локальной сборке: два куска макета их содержали). Теперь в
 * скриптах русского домена есть только ссылка на кусок, который он
 * никогда не запрашивает.
 *
 * `ssr: false` ничего не теряет: и счётчик, и плашка живут только в
 * браузере, на сервере компонент и раньше ничего не рисовал.
 */
export const Ga4Lenivyj = dynamic(() => import('./ga4-klient').then((m) => m.Ga4Klient), {
  ssr: false,
});
